import { SvelteComponent, init, safe_not_equal, update_slot, transition_in, transition_out, empty, insert, group_outros, check_outros, detach, create_slot } from 'svelte/internal';
import UAParser from 'ua-parser-js';
import { onMount } from 'svelte';

/* src/lib/DeviceDetector.svelte generated by Svelte v3.23.0 */

function create_if_block(ctx) {
	let current;
	const default_slot_template = /*$$slots*/ ctx[8].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[7], null);

	return {
		c() {
			if (default_slot) default_slot.c();
		},
		m(target, anchor) {
			if (default_slot) {
				default_slot.m(target, anchor);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 128) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[7], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(default_slot, local);
			current = true;
		},
		o(local) {
			transition_out(default_slot, local);
			current = false;
		},
		d(detaching) {
			if (default_slot) default_slot.d(detaching);
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*showSlot*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*showSlot*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*showSlot*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { showInDevice = undefined } = $$props;
	let { showInBrowser = undefined } = $$props;
	let { showInOs = undefined } = $$props;
	let showSlot = false;

	onMount(() => {
		const uaParser = new UAParser();
		let detectedBrowser = uaParser.getBrowser();
		let detectedDevice = uaParser.getDevice();
		let detectedOs = uaParser.getOS();
		let show = true;

		if (showInDevice && !equals(getDevice(detectedDevice), showInDevice)) {
			show = false;
		}

		if (showInBrowser && !equals(formatter(detectedBrowser.name), showInBrowser)) {
			show = false;
		}

		if (showInOs && !equals(formatter(detectedOs.name), showInOs)) {
			show = false;
		}

		$$invalidate(0, showSlot = show);
	});

	const getDevice = device => {
		if (!device.type) {
			return "desktop";
		}

		return formatter(device.type);
	};

	const formatter = string => string.toLowerCase().normalize("NFD").replace(/ /g, "").replace(/[^\w\s]/gi, "").replace(/[\u0300-\u036f]/g, "");

	const equals = (value, option) => {
		if (Array.isArray(option)) {
			return option.some(item => value === formatter(item));
		}

		return value === formatter(option);
	};

	let { $$slots = {}, $$scope } = $$props;

	$$self.$set = $$props => {
		if ("showInDevice" in $$props) $$invalidate(1, showInDevice = $$props.showInDevice);
		if ("showInBrowser" in $$props) $$invalidate(2, showInBrowser = $$props.showInBrowser);
		if ("showInOs" in $$props) $$invalidate(3, showInOs = $$props.showInOs);
		if ("$$scope" in $$props) $$invalidate(7, $$scope = $$props.$$scope);
	};

	return [
		showSlot,
		showInDevice,
		showInBrowser,
		showInOs,
		getDevice,
		formatter,
		equals,
		$$scope,
		$$slots
	];
}

class DeviceDetector extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			showInDevice: 1,
			showInBrowser: 2,
			showInOs: 3
		});
	}
}

export default DeviceDetector;
